import Vue from 'vue'
import Vuex from 'vuex'
import config from "@/settings/config.js"
import _axios from '@/services/axios'


Vue.use(Vuex)

const state = {
  checkOut:{
    senderNumber: "",
    recepientNumber:"",
    key:"",
    product:
     {
        salesCurrencyAmount: 0,
        baseCurrencyAmount: 0,
        inHouseServiceFeeTotal: 0,
        paymentProviderServiceFeeTotal: 0,
        totalAmount: 0
      }
  },
  payment:
  {
    Payfasturl:'',
    merchantId:'',
    merchantKey:'',
    returnUrl:'',
    cancelUrl:'',
    notifyUrl:'',
    mPaymentId:'',
    amount:'',
    itemName:'',
    itemDescription:'',
    signature:'',
    totalAmount:0
  }
}

const mutations = {
  addProductToCheckOut(state,checkOut)
  {
    state.checkOut=checkOut;
  },
  InitiatePayment(state,value)
  {
    state.payment=value;
  }
}

const actions = {
  addProductToCart(state,name)
  {
    state.commit('addProductToCart',name)
  },
  addProductToCheckOut(state,checkOut)
  {
    state.commit('addProductToCheckOut',checkOut)
  },
  async CheckOutProcess (state,checkOut) {
    try {
      return await _axios.post(config.initiatePayment,checkOut).then(response=>
      {
        state.commit("InitiatePayment",response.data);
        return "complete";
      })
    } catch (error) {
      if (error.response && error.response.status === 401)
       {
          window.localStorage.clear(); 
          window.location = "/callback?type=warning&msg=session has expired, please Login";
        }
      else
        console.error(error);
      throw(error);
    }
  }
}
const getters = {
   checkOut:state=>state.checkOut,
   payment:state=>state.payment
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
